interface TagProps {
  label: string;
  tone?: "secondary" | "accent" | "primary";
}

const toneMap = {
  secondary: "bg-secondary-100 text-secondary-900 border-secondary-200",
  accent: "bg-accent-100 text-accent-900 border-accent-200",
  primary: "bg-primary-100 text-primary-800 border-primary-200",
};

export default function Tag({ label, tone = "secondary" }: TagProps) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-md text-[11px] md:text-xs border whitespace-nowrap ${toneMap[tone]}`}
    >
      {label}
    </span>
  );
}